import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const element = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
const container = document.getElementById('root');
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, element);
} else {
  ReactDOM.createRoot(container).render(element);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
